import { entity, list } from "./base";
import { concatModules } from "@/utility";
import utility from "@/utility";

const initialEntity = {
};

const name = "answers";

const answerEntityModule = {
  mutations: {
  },
  actions: {
  },
  getters: {
  }
};

const questionListModule = {
  state: {
    answers: [],
    total: 0,
    page: 1,
    perPage: 20, //変えられるようにする
    sort: {},
    loading: false,
    loaded: false,
    processing: false,
    questionText: '',
    answerMethod: null,
    entity: {},
    templates: []
  },
  mutations: {
    answerMethod(state, payload) {
      state.answerMethod = payload.method;
    },
    succeededAnswers(state, { entities, total, page, question }) {
      state.answers = entities;
      state.total = total;
      state.page = page;
      state.loading = false;
      state.loaded = true;
      state.error = false;
      state.questionText = question;
    },
    succeededChart(state, payload) {
      state.entity = payload.entity;
      state.loading = false;
      state.loaded = true;
      state.error = false;
      state.errorMessages = [];
    },
    setTemplates(state, payload) {
      state.templates = payload.templates;
      state.total = payload.total;
      state.page = payload.page;
      state.loading = false;
      state.loaded = true;
      state.error = false;
    }
  },
  actions: {
    indexQuestions({ commit, getters }, { id }) {
      commit("loading");

      return new Promise((resolve, reject) => {
        this.$axios
          .get(`/questions/${id}`)
          .then((response) => {
            commit("succeeded", {
              entities: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    indexAnswers(
      { commit, getters },
      { id, page, filters = [], sort = {}, user_id = "", extra = {}, productId }
    ) {
      commit("loading");

      let params = {
        page,
        perPage: getters.perPage,
        filters: JSON.stringify(filters),
        sorts:
          Object.keys(sort).length > 0
            ? JSON.stringify([sort])
            : undefined,
        user_id,
        productId
      };

      // 追加のパラメータがあれば追加
      if (Object.keys(extra).length) {
        params.extra = extra;
      }

      return new Promise((resolve, reject) => {
        this.$axios
          .get(`/${name}/list/${id}`, {
            params: params
          })
          .then((response) => {
            commit("succeededAnswers", {
              entities: response.data.data.list,
              total: response.data.data.total,
              page: page,
              question: response.data.data.question
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    show({ commit }, { pk,productId }) {
      commit("loading");

      return new Promise((resolve, reject) => {
        this.$axios // axios
          .get(`/${name}/chart/${pk}`, {
            params: {
              productId: productId
            }
          })
          .then((response) => {
            commit("succeededChart", {
              entity: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    downloadCSV({ commit, getters }, { id,productId }) {
      const store = this;

      commit("processing");

      return new Promise((resolve, reject) => {
        store.$axios // axios
          .post(`/${name}/csv/download/${id}`, {
            productId: productId
          }, {
            responseType: "blob"
          })
          .then((response) => {
            commit("processed");

            if (response.data.size) {
              let blob = new Blob([response.data], { type: "application/csv" });
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = `download_${name}.csv`;
              link.click();
            } else {
              utility.$message({
                type: "warning",
                message: "ファイルが存在しません。",
                showClose: true,
                customClass: "el-message-content-position"
              });
            }

            utility.$message({
              type: "success",
              message: "CSVを出力しました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", { error });

            reject(error);
          });
      });
    },
    indexTemplates(
      { commit, getters },
      { page, filters = [], sort = {} }
    ) {
      commit("loading");

      let params = {
        page,
        perPage: getters.perPage,
        filters: JSON.stringify(filters),
        sorts:
          Object.keys(sort).length > 0
            ? JSON.stringify([sort])
            : undefined
      };

      return new Promise((resolve, reject) => {
        this.$axios
          .get("/answers/templates", {
            params: params
          })
          .then((response) => {
            commit("setTemplates", {
              templates: response.data.data,
              total: response.data.total,
              page: page
            });
            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {
    answers(state) {
      return state.answers;
    },
    questionText(state) {
      return state.questionText;
    },
    answerMethod(state) {
      return state.answerMethod;
    },
    entity(state) {
      return state.entity || {};
    },
    templates(state) {
      return state.templates;
    },
    total(state) {
      return state.total || 0;
    },
    page(state) {
      return state.page || 1;
    },
    perPage(state) {
      return state.perPage || 10;
    },
    pageLength(state) {
      if (state.total > 0) {
        return Math.ceil(state.total / state.perPage);
      } else {
        return 0;
      }
    },
    sort(state) {
      return state.sort || {};
    },
    isLoading(state) {
      return state.loading;
    },
    isLoaded(state) {
      return state.loaded;
    },
    isProcessing(state) {
      return state.processing;
    }
  }
};

const entityModule = entity(name, initialEntity);
const listModule = list(name);

export const answers = {
  namespaced: true,
  modules: {
    list: concatModules(listModule, questionListModule),
    entity: concatModules(entityModule, answerEntityModule),
  }
};
